import React, { memo } from 'react';
import { ApartmentFilterInfo } from '../../../ApartmentsFilter/ApartmentFilterCard/ApartmentFilterInfo';
import { ApartmentsGallery } from '../ApartmentsGallery';
import { ApartmentInfoBlock } from '../ApartmentInfoBlock';
import { BottomPhoneButton } from '../../../BottomPhoneButton';
import { Apartment } from '../../../../../graphql/graphql';
import { PhoneButtonClickHandler } from '../../../BottomPhoneButton/types';
import { Content, PhoneButton } from './styled';
import { useImageAlt } from '../../../../../hooks/useImageAlt';

interface ApartmentModalContentProps {
  apartment: Apartment;
  imgDescription: string;
  phones: string[] | null;
  isVisible: boolean;
  onClickHandler: PhoneButtonClickHandler;
  setIsVisible: (value: boolean) => void;
}

export const ApartmentModalContent: React.FC<ApartmentModalContentProps> = memo(
  ({
    apartment,
    phones,
    onClickHandler,
    setIsVisible,
    isVisible,
    imgDescription
  }) => {
    const imgAlt = useImageAlt({
      rooms: apartment.rooms,
      area: apartment.area,
      description: imgDescription
    });

    return (
      <Content>
        <ApartmentFilterInfo item={apartment} isModalView />
        <ApartmentsGallery photos={apartment.photos} imgAlt={imgAlt} />
        <ApartmentInfoBlock
          apartment={apartment}
          phones={phones}
          onClickHandler={onClickHandler}
          setIsVisible={setIsVisible}
          isVisible={isVisible}
        />
        <PhoneButton>
          <BottomPhoneButton
            stat="residence-apartment-phones-btn"
            phones={phones}
            clickHandler={onClickHandler}
            setIsVisible={setIsVisible}
            isVisible={isVisible}
          />
        </PhoneButton>
      </Content>
    );
  }
);

ApartmentModalContent.displayName = 'ApartmentModalContent';
